import guest from '@/router/middleware/guest';
import OptOutForm from './optOutOfSurvey.vue';


export default [
  {
    path: '/optOut/:email/:username/:collectionType/:collectionID/:loginKey(.*)',
    name: 'optOut',
    component: OptOutForm,
    meta: {
      middleware: [guest]
    }
  }
];
